import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs/Subject';

@Injectable()
export class InjectorService {



}



// WEBPACK FOOTER //
// ./src/app/services/injector.service.ts